import { Box, FormControl, IconButton, InputAdornment, InputLabel, ListItemText, MenuItem, Checkbox, Select, Button, TextField } from "@material-ui/core";
import { Close, Refresh, Search } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UniDialog from "../Common/UniDialog";
import {useDispatch, useSelector} from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  formControl: {
    marginRight: theme.spacing(2),
    minWidth: 180,
  },
  actionButtons: {
    marginLeft: theme.spacing(2),
    alignSelf: 'center'
  },
}));


export function SearchBar(props) {
  const { onSearch, resetList, handleSearchMulti, branchList} = props
  const { t } = useTranslation('advancedSearch')
  const classes = useStyles()
  const [warehouse, setWarehouse] = useState([-1]);

  const AUTOCOMPLETE_ALL = {id: -1, name: t('common:all')};

  const [searchKeyword, setSearchKeyword] = useState("");
  const [orderType, setOrderType] = useState(AUTOCOMPLETE_ALL);
  const [searchBy, setSearchBy] = useState('tno');
  const [multiLineOpen, setMultiLineOpen] = useState(false);
  const [tnos, setTnos] = useState([]);
  const [tnosRaw, setTnosRaw] = useState('');
  const [tnosCount, setTnosCount] = useState(0);
  const [customer, setCustomer] = useState('ALL');
  const [extensionNo, setExtensionNo] = useState('');

  const searchOptions = [
    { value: 'order_id', label: t('order_id') },
    { value: 'order_sn', label: t('order_sn') },
    { value: 'tno', label: t('tracking_number') },
    { value: 'mobile', label: t('consignee_phone') },
    { value: 'name', label: t('name') },
    { value: 'address', label: t('address') },
  ];

  const handleWarehouseChange = (event) => {
    let valueArray = event.target.value
    //-1 is selection for all, since 0 is taken by a hidden area
    if (_.last(valueArray) === -1) {
      valueArray = [-1]
    } else {
      _.pull(valueArray, -1)
    }
    setWarehouse(valueArray)
  }

  useEffect(() => {
    if (props.open) {
      handleSearchMulti(false);
      setCustomer('ALL');
    }
  }, [props.open])

  return (<>

    <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {
          props.partnerList?.length > 0 &&
          <Autocomplete
          style={{ minWidth: 150, maxWidth: 150 }}
          options={[AUTOCOMPLETE_ALL, ...props.partnerList] || [AUTOCOMPLETE_ALL]}
            getOptionLabel={(option) => option?.name}
            limitTags={1}
            onChange={(event, value) => {
              setOrderType(value);
              setCustomer('ALL');
            }}
            renderInput={(params) => (
              <TextField {...params} label={t("partner")} variant="outlined"/>
            )}
            id="advancedsearch_autocomplete"
            className={classes.formControl}
            value={orderType}
            fullWidth
            margin="normal"
          />
        }
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ minWidth: 150 }}
          size="small"
        >
          <InputLabel>{t('customer')}</InputLabel>
          <Select
            value={customer}
            onChange={(event) => {setCustomer(event.target.value);}}
          >
            <MenuItem value='ALL'>{t('common:all')}</MenuItem>
            {
              orderType?.customers?.length > 0 &&
              orderType?.customers.map((customer) => (
                <MenuItem value={customer.id}>{customer.name}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ minWidth: 250, maxWidth: 400 }}
          size="small">
          <TextField
            id='advancesearch-warehouselist-textfield'
            defaultValue={[-1]}
            label={t('area')}
            variant="outlined"
            select
            fullWidth
            SelectProps={{
              multiple: true,
              value: warehouse,
              onChange: handleWarehouseChange,
              renderValue: (selected) => _.map(selected, (value) => {
                let find = _.find(branchList, { 'id': value })
                return (find && find['name']) || t('common:all')
              }).join(', ')
            }}
          >
            <MenuItem value={-1}>{t('common:all')}</MenuItem>
            {
              branchList && branchList.map((branch, index) => {
                return <MenuItem key={index} value={branch.id}>
                  <Checkbox checked={warehouse.indexOf(branch.id) > -1} />
                  <ListItemText primary={`${branch.name}`} />
                </MenuItem>
              })
            }
          </TextField>
        </FormControl>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ minWidth: 250 }}
          size="small"
        >

          <InputLabel>{t('search_by')}</InputLabel>
          <Select
            value={searchBy}
            onChange={(event) => setSearchBy(event.target.value)}
          >
            {searchOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          id="advancedsearch_searchinput_textfield"
          variant="outlined"
          autoFocus
          endAdornment={
            <InputAdornment position='end'>
              {
                searchKeyword.length > 0 ?
                  <IconButton
                    aria-label="clear-input"
                    size='small'
                    onClick={clearInput}
                  >
                    <Close color='error' />
                  </IconButton>
                  :
                  <></>
              }
            </InputAdornment>
          }
          size='small'
          placeholder={t('common:search')}
          onChange={_handleSearchChange}
          value={searchKeyword}
          style={{ minWidth: 250 }}
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              _handleSearch()
            }
          }}
        />
        {searchBy === "mobile" && (
          <TextField
            style={{ minWidth: 180, marginLeft: 10 }}
            id="advancedsearch_extentionnum_textfield"
            label={t('extension_num')}
            value={extensionNo}
            variant="outlined"
            onChange={(event) => setExtensionNo(event.target.value)}
          />
        )}
      </div>
      <div className={classes.actionButtons}>
        <IconButton
          color='primary'
          onClick={_handleSearch}
          disabled={!orderType?.id}
        >
          <Search />
        </IconButton>
        <IconButton
          color='primary'
          onClick={resetList}
        >
          <Refresh />
        </IconButton>

        <Button style={{ marginLeft: 10 }}
          disabled={(searchBy != 'tno')}
          variant='contained'
          onClick={() => { setMultiLineOpen(true) }}
        >
          {t('multi_search')}
        </Button>
      </div>
    </Box>

    <UniDialog
      open={multiLineOpen}
      autoClose={true}
      onClose={() => {
        setTnosRaw('');
        setTnos([]);
        setTnosCount(0);
        setMultiLineOpen(false);
      }}
      onFinish={() => {
        handleSearchMulti(true);
        onSearch(warehouse, orderType.id, searchBy, tnos.toString(), customer)
        setTnosRaw('');
        setTnos([]);
        setTnosCount(0);
        setMultiLineOpen(false);
      }}

      title={t('multi_search')}
      finishButtonText={t('common:search')}

      maxwidth='sm'
      fullWidth={true}
    >
      <div>{t('input_ant_parcels')}</div>

      <TextField multiline
        rows={20}
        fullWidth={true}
        autoFocus={true}
        variant="outlined"
        value={tnosRaw}
        onChange={handleTnosInput}
      />

      <div style={{ textAlign: 'right' }}>
        {tnosCount}
      </div>
    </UniDialog>

  </>)

  function _handleSearch() {
    handleSearchMulti(false);
    setExtensionNo('');
    onSearch(warehouse, orderType.id, searchBy, searchKeyword, customer, extensionNo)
    clearInput()
  }

  function _handleSearchChange(event) {
    setSearchKeyword(event.target.value)
  }

  function clearInput() {
    setSearchKeyword("")
  }

  function handleTnosInput(event) {
    let tnosArray = event.target.value.split('\n');
    let tnosCurr = [];
    let tnosCurrCount = 0;

    tnosArray.forEach((element) => {
      if (element) {
        tnosCurr.push(element);
        tnosCurrCount++;
      }
    });

    setTnosRaw(event.target.value);
    setTnos(tnosCurr);
    setTnosCount(tnosCurrCount);
  }

}
